import { render, staticRenderFns } from "./EmbryoTable.vue?vue&type=template&id=5eb2738c&"
import script from "./EmbryoTable.vue?vue&type=script&lang=js&"
export * from "./EmbryoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports